<div class="h-100">
    <div class="row h-100">
        <div class="col">
            <hr>
            <h6 class="text-uppercase collapsible-text" (click)="programsTasksCollapsible.toggleChange()">
                {{'PROGRAMS-TASKS' | translate}}&nbsp;
                <app-collapsible #programsTasksCollapsible [storageKey]="'case-member'"
                    (collapsibleToggle)="caseMemberCollapsed=$event">
                </app-collapsible>
            </h6>
        </div>
    </div>
    <div *ngIf="taskLoading && !caseMemberCollapsed">
        <div class="row justify-content-center">
            <span class="k-icon k-i-loading kendo-loading-icon"></span>
        </div>
    </div>
    <div *ngIf="!taskLoading && !caseMemberCollapsed" class="mt-3">
        <span style="color: rgba(0, 0, 0, 0.25);" *ngIf="casesTasks.length === 0" class="ml-4">
            {{'NONE-ENROLLED' | translate }}
        </span>
        <div>
            <div *ngFor="let case of casesTasks; let i = index;trackBy:trackByCase" class="row mb-1">
                <div class="col pr-0 pl-4">
                    <kendo-card class="w-100" style="border: none; background-color: #f5f6fb;">
                        <kendo-card-header style="border: none; background-color: #f5f6fb;" class="pr-0">
                            <div class="row w-100 d-flex align-items-center">
                                <div class="col-11 my-auto">
                                    <div class="row h-100">
                                        <div class="col">
                                            <div class="row">
                                                <div class="col text-justify my-auto label-channel montserrat pl-0"
                                                    style="margin-top: auto;">
                                                    <a [routerLink]="['/case', case.id]" class="montserrat">
                                                        {{case.channel}}
                                                        <span class="montserrat"
                                                            *ngIf="case.referredToCommunityProgram !== null">:
                                                            {{case.referredToCommunityProgram.name}}
                                                            {{'BY' | translate }}
                                                            {{case.referredToCommunityProgram.organization.name}}
                                                        </span>
                                                    </a>
                                                    <span
                                                        style="top: 0; height: 22px; color: black; background-color: #e7e8f0;"
                                                        class="badge badge-pill badge-secondary ml-2 badge-program">
                                                        {{case.tasks.length}}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <div class="col-7 my-auto label-total montserrat pl-0 text-uppercase"
                                                    style="margin-bottom:auto;font-size:smaller;">
                                                    {{'MANAGER' | translate}}:&nbsp;{{case.manager}}
                                                </div>
                                                <div *ngIf="case.channelWorkflowStatus !== null"
                                                    class="col-5 my-auto label-total montserrat pl-0 text-uppercase"
                                                    style="margin-bottom:auto;font-size:smaller;">
                                                    {{'CHANNEL-WORKFLOW-STATUS' | translate}}:&nbsp;
                                                    {{case.channelWorkflowStatus.displayName}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-1 my-auto text-right pr-0">
                                    <app-collapsible [useSessionStorage]="true" [storageKey]="'task-member-' + case.id"
                                        (collapsibleToggle)="updateTaskCollapsed(case.id, $event)">
                                    </app-collapsible>
                                </div>
                            </div>
                        </kendo-card-header>
                        <kendo-card-body *ngIf="!collapseTasks.get(case.id)"
                            style="padding-top:0; padding-bottom:0; margin-left: 4pt; border-left: 4pt solid #bfc4cd;"
                            class="pr-3">
                            <kendo-grid #grid [data]="case.tasks" [loading]="loading" [sortable]="true"
                                [resizable]="true" [sort]="casesTasks[i].sort" [navigable]="true"
                                (dataStateChange)="dataStateChange($event, grid, casesTasks[i])">
                                <kendo-grid-messages noRecords="{{ 'NO-TASKS' | translate }}">
                                </kendo-grid-messages>
                                <kendo-grid-column field="name" title="{{ 'TASK' | translate }}" [width]="120"
                                    class="emphasizedLabel ellipsis-text">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <a class="pointer" (click)="openTask(dataItem)" title="{{dataItem.name}}">
                                            <strong [ngClass]="{'completed-task': dataItem.status === 'Completed'}">{{
                                                dataItem.name }}
                                            </strong>
                                        </a>
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="assigneeName" title="{{ 'ASSIGNED-TO' | translate }}"
                                    [width]="90">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.assigneeName}}
                                        <a *ngxPermissionsOnly="['ROLE_OPERATOR','ROLE_PROGRAM_LEAD', 'ROLE_PROGRAM_SUPPORT']"
                                            class="pointer float-right" title="{{'REASSIGN' | translate}}"
                                            (click)="openTaskAssigneeDialog(dataItem)">
                                            <i *ngIf="dataItem.status === 'Open'" class="fas fa-undo icon-info"></i>
                                        </a>
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="openedOn" title="{{ 'OPENED-ON' | translate }}" [width]="70"
                                    filter="date" format="{0:d}">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <span>{{intl.formatDate(intl.parseDate(dataItem.openedOn), "g")}}</span>
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="dueDate" title="{{ 'DUE-ON' | translate }}" [width]="80"
                                    filter="date" format="{0:d}">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <span>{{intl.formatDate(intl.parseDate(dataItem.dueDate), "d")}}</span>
                                        <a *ngIf="dataItem.status === 'Open'" class="pointer float-right"
                                            title="{{'EDIT' | translate}}" (click)="openTaskDueDateDialog(dataItem);">
                                            <i class="fas fa-undo icon-info"></i>
                                        </a>
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="priority" title="{{ 'PRIORITY' | translate }}" [width]="49"
                                    class="text-center" [columnMenu]="false">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <div [className]="dataItem.priorityBadgeClass">
                                            {{ dataItem.priority.charAt(0) }}
                                        </div>
                                        <div class="change-icon">
                                            <a *ngIf="dataItem.status === 'Open'" class="pointer float-right"
                                                title="{{'EDIT' | translate}}"
                                                (click)="openTaskPriorityDialog(dataItem);">
                                                <i class="fas fa-undo icon-info"></i>
                                            </a>
                                        </div>
                                    </ng-template>
                                </kendo-grid-column>
                            </kendo-grid>
                        </kendo-card-body>
                    </kendo-card>
                </div>
            </div>
        </div>
        <div class="row mr-4 mb-2 mt-5">
            <div class="col">
                <h6 class="text-uppercase ml-4">{{ (communityEnabled ? 'AVAILABLE' : 'NOT-ENROLLED') | translate}}</h6>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-5 ml-4">
                <div hidden id="available"> {{ (communityEnabled ? 'AVAILABLE' : 'NOT-ENROLLED') | translate}}
                </div>
                <kendo-combobox class="w-100" id="notEnrolledChannelsDropdown" [data]="groupedChannels"
                    [textField]="'name'" [valueField]="'id'" [filterable]="true"
                    (filterChange)="filterNotEnrolledChannels($event)" (close)="searchTerm=''"
                    [(ngModel)]="channelToEnroll" [attr.aria-labelledby]="'available'">
                </kendo-combobox>
            </label>
            <div class="col-6 text-left">
                <button appPreventClick preventTime="8000" kendoButton type="button" [primary]="true"
                    [disabled]="channelToEnroll === undefined" (click)="caseDialogOpened = true">
                    {{ 'ENROLL' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>

<app-case-enrollment *ngIf="caseDialogOpened && member !== undefined" [member]="member" [channel]="channelToEnroll"
    (cancelling)="cancelledCaseEnrollment()" (refresh)="getChannelsData()">
</app-case-enrollment>

<!-- task assignment dialog -->
<app-task-assign [task]="task" [dialogOpened]="assigneeDialogOpened" (closing)="closeTaskAssigneeDialog();"
    (save)="updateTaskAssignee($event)">
</app-task-assign>

<!-- duedate task dialog -->
<app-task-duedate [task]="task" [dialogOpened]="taskDueDateOpened" (closing)="closeTaskDueDateDialog()"
    (save)="updateTaskDueDate($event)">
</app-task-duedate>

<!-- reassign task dialog -->
<app-task-priority [task]="task" [dialogOpened]="priorityDialogOpened" (closing)="closeTaskPriorityDialog();"
    (save)="updateTaskPriority($event)">
</app-task-priority>

<!--open task dialog, adjusting width to get toolbar in notes on one line -->
<div class="k-overlay" *ngIf="taskOpened"></div>
<kendo-window id="task-detail" [width]="1300" [height]="590" *ngIf="taskOpened" (close)="closeTaskDialog()"
    style="position:fixed" [top]="60" [state]="windowState">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 class="ellipsis-text">{{selectedTask.name}}</h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <button kendoWindowRestoreAction></button>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <app-task-detail [task]="selectedTask" [autoComplete]="autoComplete" (completed)="onTaskCompleted()"
        (closeTaskDetail)="closeTaskDetail()" (followUpTaskAddedEvent)="getChannelsData()" [isDialog]="true">
    </app-task-detail>
    <kendo-dialog-actions style="position:absolute;margin-left:-16px" class="w-100 mt-3">
        <button kendoButton [primary]="true" type="button" (click)="closeTaskDialog()">
            {{ 'CLOSE' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-window>